var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AngleBottom, AngleTop } from '@mehilainen/mds-icons';
import { colors } from '@mehilainen/mds-tokens';
import { Button, buttonClasses, styled } from '@mui/material';
import { getFamilyProfileColor, } from '../../theme/familyProfileColors';
import { shouldForwardProp } from '../mds-shared';
const StyledButton = styled(Button, { shouldForwardProp })(({ $familyProfileColor }) => ({
    [`&.${buttonClasses.colorPrimary}.${buttonClasses.contained}`]: {
        backgroundColor: colors[$familyProfileColor][200],
        color: colors[$familyProfileColor][600],
        '&:hover': {
            backgroundColor: colors[$familyProfileColor][300],
            color: colors[$familyProfileColor][700],
        },
        '&:active': {
            backgroundColor: colors[$familyProfileColor][300],
            color: colors[$familyProfileColor][800],
        },
    },
}));
const defaultProps = {
    familyMemberIndex: 0,
    open: false,
    size: 'medium',
};
/**
 * UserButton component
 *
 * Props:
 * - `familyMemberIndex`?: number - The index number of family profile member
 * - `name`?: ReactNode -  The main text of the list item
 * - `open`?: boolean - Toggle caret icon
 * - `size`?: 'small' | 'medium' - Component size variant
 *
 * @example
 * <UserButton
 *    name="Marjaana"
 *    open={isOpen}
 *    onClick={() => handleClick()}
 * />
 */
export const UserButton = (props) => {
    const { familyMemberIndex = defaultProps.familyMemberIndex, name, open = defaultProps.open, size = defaultProps.size } = props, otherProps = __rest(props, ["familyMemberIndex", "name", "open", "size"]);
    return (_jsx(StyledButton, Object.assign({ "$familyProfileColor": getFamilyProfileColor(familyMemberIndex), endIcon: open ? _jsx(AngleTop, {}) : _jsx(AngleBottom, {}), size: size }, otherProps, { children: name })));
};
